import { render, staticRenderFns } from "./MobileFooter.vue?vue&type=template&id=4a530ad5&scoped=true&"
import script from "./MobileFooter.vue?vue&type=script&lang=js&"
export * from "./MobileFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a530ad5",
  null
  
)

export default component.exports